import type { IResponseKnowledgeBaseCanDeleteDocument, KnowledgeBase } from 'entities/KnowledgeBase'

export const getDescriptionForDeleteModal = (
  ids: number[],
  knowledgeBase: KnowledgeBase,
  canDeleteState: IResponseKnowledgeBaseCanDeleteDocument
) => {
  const { documentsCount } = knowledgeBase
  const isMultipleFiles = ids.length > 1
  const isRemovingAllDocuments = ids.length === documentsCount
  const { chatbots_count: agentCounter } = canDeleteState.meta || { chatbots_count: 0 }

  if (isMultipleFiles) {
    if (agentCounter === 0) {
      return 'These files are not used by any AI Agents. Deleting them won’t affect their responses. However, this action cannot be undone.'
    }
    if (isRemovingAllDocuments) {
      return 'These files are used by some AI agents. Deleting them will disable those agents and may affect responses. This action cannot be undone.'
    }
    if (agentCounter > 1) {
      return 'These files are used by AI Agents. Deleting them may impact their responses. This action cannot be undone.'
    } else {
      return 'These files are used by AI agent. Deleting them may affect the responses provided. This action cannot be undone.'
    }
  } else {
    if (agentCounter === 0) {
      return 'This file is not connected to any AI Agents. Deleting it is safe, but this action cannot be undone.'
    }
    if (isRemovingAllDocuments) {
      return 'This file is used by some AI agents. Deleting it will disable those agents and may affect responses. This action cannot be undone.'
    }
    if (agentCounter > 1) {
      return 'This file is used by AI Agents. Deleting it may impact their responses. This action cannot be undone.'
    } else {
      return 'This file is used by AI agent. Deleting it may affect the responses provided. This action cannot be undone.'
    }
  }
}
